// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-map-main-box {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: row;
}
@media only screen and (max-width: 767px) and (orientation: portrait) {
  .location-map-main-box {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/location-warning/location-warning.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AACJ;AAAI;EALJ;IAMQ,sBAAA;EAGN;AACF","sourcesContent":[".location-map-main-box {\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    flex-direction: row;\n    @media only screen and (max-width: 767px) and (orientation: portrait) {\n        flex-direction: column;\n      }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
